import ConfirmButton from '@components/atoms/buttons/confirmButton';
import LogoutButtonContainer from '@components/atoms/container/logoutButtonContainer';
import Spinner from '../spinner/spinner';
import TranslationManager from '@shared/assets/locale/translationsManager';

/**
 * Constants
 */
const LITERALS = 'PAGES.SETTINGS.LOGOUT';

/**
 * Props for the logout button component
 * @param displaySpinner - Whether the spinner is displayed
 * @param focused - Whether the component is focused
 * @param callback - The callback function to logout
 */
interface LogoutButtonProps {
  displaySpinner: boolean;
  focused: boolean;
  callback: () => void;
}

/**
 * Logout button component
 * Handles the logout button functionality and display.
 *
 * @returns {JSX.Element} Logout button component
 */
export default function LogoutButton({
  displaySpinner,
  focused,
  callback,
}: LogoutButtonProps) {
  return (
    <>
      <LogoutButtonContainer id={'spinner'}>
        <ConfirmButton
          id={'logoutButton'}
          onClick={callback}
          focused={focused}
          width={300}
        >
          {TranslationManager.get(`${LITERALS}.BUTTON`)}
        </ConfirmButton>
        {displaySpinner ? (
          <Spinner type='logout' data-testid='spinner' />
        ) : null}
      </LogoutButtonContainer>
    </>
  );
}
